<template>
  <div class="section-review-footer">
    <button
      @click="handleReviewClick()"
    >
      <icon
        name="refresh-arrow-circle"
        class="small-icon"
      ></icon>
      Review All
    </button>
    <button
      v-if="isSimulationComplete"
      @click="handleReviewClick('incorrect')"
    >
      <icon
        name="cross-rotated-circle"
        class="small-icon"
      ></icon>
      Review Incorrect
    </button>
    <button
      v-else
      @click="handleReviewClick('incomplete')"
    >
      <icon
        name="cross-rotated-circle"
        class="small-icon"
      ></icon>
      Review Incomplete
    </button>
    <button
      @click="handleReviewClick('flagged')"
    >
      <icon
        name="flag-filled-white"
        class="small-icon"
      ></icon>
      Review Flagged
    </button>
    <span class="spacer"></span>
    <button
      v-if="isSimulationComplete"
      @click="$emit('return-to-performance')"
    >
      <icon
        name="right-arrow-boxed"
        class="small-icon"
      ></icon>
      Return to Performance
    </button>
    <button
      v-else
      @click="$emit('submit-section')"
    >
      <icon
        name="right-arrow-boxed"
        class="small-icon"
      ></icon>
      Submit Section
    </button>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    isSimulationComplete: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleReviewClick(param) {
      this.$emit('review', param);
    },
  },
};
</script>

<style lang='scss' scoped>
.section-review-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.5rem;
  gap: 2rem;

  .spacer {
    flex-grow: 1;
  }

  button {
    background: transparent;
    border: none;
    color: white;
    font-size: 20px;
    font-weight: 600;
  }

  .small-icon {
    height: 17px;
    margin-right: 0.25rem;
  }
}
</style>
